import { useMutation } from '@tanstack/react-query'
import { API_ROUTES } from '@/constants/routes'
import { api } from '@/lib/axios'

interface ImportResult {
    id: number
    name: string
    pages: { id: number; page_number: number; canvas_json: Record<string, unknown> }[]
    width_mm: number
    height_mm: number
}

export function useDocumentImport() {
    return useMutation({
        mutationFn: async (formData: FormData): Promise<ImportResult> => {
            const { data } = await api.post(API_ROUTES.importDocument, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            })
            return data
        },
    })
}

export function useGoogleDriveImport() {
    return useMutation({
        mutationFn: async (params: {
            google_access_token: string
            file_id: string
            file_name?: string
            mime_type?: string
        }): Promise<ImportResult> => {
            const { data } = await api.post(API_ROUTES.importGoogleDrive, params)
            return data
        },
    })
}
